import { render, staticRenderFns } from "./UploadFileList.vue?vue&type=template&id=6d8f676e&"
import script from "./UploadFileList.vue?vue&type=script&lang=js&"
export * from "./UploadFileList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports